export class GameConstants {
    static readonly WINDMILL_SYMBOL_ID = 13;
    static readonly SHUTTER_SYMBOL_ID = 14;
    static readonly WILD_SYMBOL_ID = 0;
}